import { AppModuleAnalyticsKeys } from '@sphere/platform';

export const AnalyticsPortalKeys: AppModuleAnalyticsKeys = {
    category: 'Portal',
    pages: {
        homeDashboard: 'Home dashboard'
    }
};

export default AnalyticsPortalKeys;
